import { parseEnv } from '@/helpers/route-utils';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { EVENT_TYPES } from 'utils';
import * as z from 'zod/v4';

export const Route = createFileRoute('/_auth/$env/events/$type/new')({
  params: parseEnv({
    otherParamsSchema: z.object({
      type: z.enum(EVENT_TYPES),
    }),
  }),
  validateSearch: zodValidator(
    z.object({
      templateId: z.string().optional(),
      copyFromEventId: z.string().optional(),
      translationSidebarOpen: z.boolean().optional(),
    }),
  ),
});
